import React, { useCallback } from 'react';
import useEkko from 'src/Common/Providers/EkkoProvider';
import PaginatedSelect from './PaginatedSelect';
import { Pagination } from '@ekkogmbh/apisdk';
import { injectFakePagination } from 'src/Common/Helper/Pagination';
interface Props {
  coordinate?: string;
  selected?: string;
  onChange: (selection: string | undefined) => void;
  disabled?: boolean;
  forwardedRef?: React.ForwardedRef<HTMLDivElement>;
}

// eslint-disable-next-line react/display-name
export const TechnologyPicker = ({ selected, disabled, coordinate, onChange }: Props): React.JSX.Element => {
  const { api } = useEkko();

  const fetchFakePagination = useCallback(
    async (pagination: Pagination) => {
      const names: string[] = [];
      if (coordinate !== undefined && coordinate !== '') {
        const integrations = await api.getAvailableDeviceIntegrations(coordinate);
        for (const i of integrations) {
          names.push(i.name);
        }
      }

      const technologies = await api.getTechnologies();
      for (const t of technologies) {
        names.push(t.name);
      }

      return injectFakePagination(names, pagination);
    },
    [api, coordinate],
  );

  return (
    <PaginatedSelect
      label={'Technology'}
      disabled={disabled}
      fetchPaginatedItems={fetchFakePagination}
      value={selected}
      onChange={(item) => onChange(item as string)}
      itemId={(item) => item}
      itemRender={(item) => item}
    />
  );
};
